// extracted by mini-css-extract-plugin
module.exports = {"mention":"_2HGQ6rYE0IOP3xpHF5uhDA","profanity":"_2Hk8DyfKoTFDmjrJ2UF3yU"};